export enum AQLeadType {
  CarryIn = 1,
  MailIn = 4,
}
